import FeatureFlags from '../FeatureFlags';
import { getIsApp, getIOSVersion } from '../AppInfo';

/**
 * Determines whether or not a user should be allowed to directly create a pro account.
 *
 * @returns {Promise<Boolean>} True if not in the iOS app or if is in the iOS app and the
 *  `appt-variation-test` flag is enabled
 * @example
 * appointmentVariation.allowed().then(allowed => {
 *   if (allowed) {
 *     // Allow sign up as a pro
 *   } else {
 *     // Redirect to login...
 *   }
 * }).catch(() => {
 *   // Redirect to login...
 * });
 */
export async function allowed(): Promise<boolean> {
  const isIOSApp: boolean = !!(getIsApp() && getIOSVersion());
  if (isIOSApp) {
    return FeatureFlags.isEnabled('appt-variation-test');
  }
  return true;
}
